import { selectAccount, updateAccount } from "app/redux/accountSlice";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {RESERVE_BASE_URL} from "../../utils/config";

export const useBusinessDetails = () => {
  const dispatch = useDispatch();
  const account = useSelector(selectAccount);
  const [showCopiedTooltip, setShowCopiedTooltip] = useState(false);

  const onUpdateAccount = async (updatedAccount: any) => {
    try {
      await dispatch(updateAccount(updatedAccount) as any).unwrap();
      toast.success("Business details updated successfully");
    } catch (e) {
      console.error(e);
      toast.error("Failed to update business details");
    }
  };

  const onCopyBookingUrl = () => {
    setShowCopiedTooltip(true);
    navigator.clipboard.writeText(
      `${RESERVE_BASE_URL}${account?.bookingLink}`
    );
    setTimeout(() => {
      setShowCopiedTooltip(false);
    }, 2000);
  };

  // const fetchResellers = async () => {
  //   try {
  //     const fetchedResellers = await dispatch(getResellers() as any).unwrap();
  //     setResellers(fetchedResellers);
  //   } catch (error: any) {
  //     console.error(error);
  //   }
  // };

  // React.useEffect(() => {
  //   fetchResellers();
  // }, []);

  return {
    account,
    onUpdateAccount,
    onCopyBookingUrl,
    showCopiedTooltip,
  };
};
